/* Breakpoint Tees — homepage interactions */
(function () {
  'use strict';

  /* ---------- Mobile nav toggle ---------- */
  var hamburger = document.getElementById('hamburger');
  var nav = document.getElementById('nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', function () {
      nav.classList.toggle('open');
      hamburger.classList.toggle('active');
    });
    nav.querySelectorAll('.nav__link').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('open');
      });
    });
  }

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    var prev = carousel.querySelector('.carousel__nav--prev');
    var next = carousel.querySelector('.carousel__nav--next');
    if (!track) return;

    var autoplay = carousel.getAttribute('data-carousel') === 'products';

    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap) || 24;
      return first.getBoundingClientRect().width + gap;
    }

    // How far we can scroll before hitting the end (with a small tolerance).
    function maxScroll() {
      return track.scrollWidth - track.clientWidth - 2;
    }

    function goNext() {
      if (track.scrollLeft >= maxScroll()) {
        track.scrollTo({ left: 0, behavior: 'smooth' }); // loop back to start
      } else {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      }
    }

    function goPrev() {
      if (track.scrollLeft <= 2) {
        track.scrollTo({ left: maxScroll(), behavior: 'smooth' }); // loop to end
      } else {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      }
    }

    if (next) next.addEventListener('click', goNext);
    if (prev) prev.addEventListener('click', goPrev);

    /* ---- Autoplay (products only), pauses on hover/interaction ---- */
    if (autoplay) {
      var timer = null;
      function play() { timer = setInterval(goNext, 3500); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      play();
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', play);
      track.addEventListener('touchstart', stop, { passive: true });
    }
  });

  /* ---------- Swatch selection (decorative on cards) ---------- */
  document.querySelectorAll('.swatches:not(.pd-swatches)').forEach(function (group) {
    group.querySelectorAll('.sw:not(.sw--more)').forEach(function (sw) {
      sw.addEventListener('click', function () {
        group.querySelectorAll('.sw').forEach(function (s) { s.classList.remove('sw--active'); });
        sw.classList.add('sw--active');
      });
    });
  });

  /* ---------- Accordions (FAQ, product details, etc.) ---------- */
  document.querySelectorAll('[data-accordion] .pd-acc__head').forEach(function (head) {
    head.addEventListener('click', function () {
      head.parentElement.classList.toggle('open');
    });
  });
})();
